import { HttpHandler, HttpHeaderResponse, HttpInterceptor, HttpProgressEvent, HttpRequest, HttpResponse, HttpSentEvent, HttpUserEvent } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IBaseModel } from 'src/app/models/base.model';
import { AuthService } from 'src/app/services/auth.service';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  isRefreshingToken = true;
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(private injector: Injector) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
    const authService = this.injector.get(AuthService);

    return next.handle(request).pipe(
      catchError(error => {
        if (error.status === 401) {
          authService.login();
          return next.handle(null);
        }

        if (error.error instanceof ErrorEvent) {
          // A client-side or network error occurred
          // TODO: Implementar tratativas para erro client-side e de rede

        } else {
          // Padrão antigo: { sucesso, mensagem }
          if (error.error && error.error.sucesso !== undefined && error.error.mensagem !== undefined) {
            return throwError(error.error as IBaseModel<any>);
          }

          // Padrão novo Result<T>: { Success, Message } ou { success, message }
          if (error.error && (error.error.Success !== undefined || error.error.success !== undefined)) {
            return throwError({
              sucesso: false,
              mensagem: {
                nome: 'Erro',
                descricao: error.error.Message ?? error.error.message ?? 'Erro ao processar a solicitação.'
              }
            } as IBaseModel<any>);
          }
        }

        // Retorno padrão
        return throwError({ sucesso: false, mensagem: { nome: 'ErroInterno', descricao: 'Ocorreu um erro ao tentar realizar a operação' } } as IBaseModel<any>);
      }));
  }}
